let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFxtR")).then(() => parcelRequire('h5GvG'));